import React from 'react';
import { componentLoader } from './componentLoader';

export const PAGE_ROUTES = {
  MyHomePage: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "my-home-page" */ /* webpackPreload: true */ './MyHomePage/MyHomePage')
    )
  ),

  QuickStart: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "quick-start" */ /* webpackPreload: true */ './QuickStart/QuickStart')
    )
  ),

  DataExtracts: React.lazy(() =>
    componentLoader(() => import(/* webpackChunkName: "data-extracts" */ './dataextracts/DataExtracts'))
  ),

  Reports: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "reports" */ /* webpackPreload: true */ './InsightReports/Reports')
    )
  ),

  Dashboards: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "dashboards-page" */ /* webpackPreload: true */ './dashboards/Dashboards')
    )
  ),

  AnalyticsDashboards: React.lazy(() =>
    componentLoader(() => import(/* webpackChunkName: "dashboards-page" */ './analyticsDashboards/AnalyticsDashboards'))
  ),

  OrgNavigatorPageContainer: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "org-navigator-page" */ /* webpackPreload: true */ './orgNavigator/OrgNavigatorPage'
        )
    )
  ),

  EngagementsPage: React.lazy(() =>
    componentLoader(
      () =>
        import(/* webpackChunkName: "engagements-hub" */ /* webpackPreload: true */ './EngagementsHub/EngagementsPage')
    )
  ),

  ProgramAlerts: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "program-alerts" */ './DetectedProgramAlerts/DetectedProgramAlerts')
    )
  ),

  WorkersPage: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "workers-hub" */ /* webpackPreload: true */ './WorkersHub/WorkersPage')
    )
  ),

  WorkerProfilePage: React.lazy(() =>
    componentLoader(
      () =>
        import(/* webpackChunkName: "profile-page" */ /* webpackPreload: true */ './WorkerProfile/WorkerProfilePage')
    )
  ),

  NewSuppliersPage: React.lazy(() =>
    componentLoader(
      () =>
        import(/* webpackChunkName: "suppliers-page-new" */ /* webpackPreload: true */ './NewSupplierHub/SupplierPage')
    )
  ),

  SupplierPage: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "supplier-page" */ /* webpackPreload: true */ './profile/supplier/SupplierPage')
    )
  ),

  ContractsHub: React.lazy(() =>
    componentLoader(
      () =>
        import(/* webpackChunkName: "contracts-hub" */ /* webpackPreload: true */ './sourcing/contracts/ContractsHub')
    )
  ),

  ContractDetails: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "contract-details" */ /* webpackPreload: true */ './sourcing/contracts/ContractDetails/ContractDetails'
        )
    )
  ),

  Frontdoor: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "frontdoor" */ /* webpackPrefetch: true */ './frontdoor/FrontdoorFormHome')
    )
  ),

  WorkRequestsPage: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "work-requests-page" */ /* webpackPreload: true */ './sourcing/workRequests/WorkRequestsPage'
        )
    )
  ),

  WorkRequestPage: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "work-request-page" */ /* webpackPreload: true */ './sourcing/workRequests/WorkRequestPage'
        )
    )
  ),

  JobApplicationsPage: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "job-applications-page" */ /* webpackPreload: true */ './sourcing/jobApplications/JobApplicationsPage'
        )
    )
  ),

  JobApplicationPage: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "job-application-page" */ /* webpackPreload: true */ './sourcing/jobApplications/JobApplicationPage'
        )
    )
  ),

  JobRequestsPage: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "job-postings-page" */ /* webpackPreload: true */ './sourcing/jobRequests/JobRequestsPage'
        )
    )
  ),

  JobRequestPage: React.lazy(() =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "job-request-page" */ /* webpackPreload: true */ './sourcing/jobRequests/JobRequestPage'
        )
    )
  ),

  TimeAndExpenses: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "time-and-expenses" */ /* webpackPreload: true */ 'tae/TimeAndExpensesHome')
    )
  ),

  Invoices: React.lazy(() =>
    componentLoader(() => import(/* webpackChunkName: "invoices-hub-page" */ 'invoices/InvoicesHome'))
  ),

  InvoicesV2: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "invoices-hub-page-2-0" */ /* webpackPreload: true */ 'invoices/InvoicesHomeV2')
    )
  ),
  Settings: React.lazy(() =>
    componentLoader(() => import(/* webpackChunkName: "settings" */ './settings/HomeSettings'))
  ),

  MyAccount: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "my-account" */ /* webpackPreload: true */ './MyAccount/MyAccount')
    )
  ),

  Designer: React.lazy(() =>
    componentLoader(() => import(/* webpackChunkName: "designer-page" */ './designer/Designer'))
  ),

  ProcessesPage: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "workflows-page" */ /* webpackPreload: true */ './workflows/ProcessesPage')
    )
  ),

  ProjectsPage: React.lazy(() =>
    componentLoader(() => import(/* webpackChunkName: "projects-page" */ './Projects/ProjectsPage'))
  ),

  TasksPage: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "tasks-page" */ /* webpackPreload: true */ './TasksPage/TasksPage')
    )
  ),

  ApiDocumentation: React.lazy(() =>
    componentLoader(
      () => import(/* webpackChunkName: "utmost-connect-api-docs" */ './documentation/UtmostConnectApiDocs')
    )
  )
};
